import { MessageCircle } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { whatsappLink } from "../i18n/translations";
import { LogoMark } from "./Logo";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="main-footer" className="relative bg-[#030303] border-t border-[rgba(197,160,89,0.15)] pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col items-center text-center">
          <LogoMark size={56} />
          <p className="mt-6 font-serif text-2xl sm:text-3xl gold-text">{t.footer_tagline}</p>
          <a
            data-testid="footer-whatsapp-link"
            href={whatsappLink(t.whatsapp_message)}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 px-6 py-3 border border-[rgba(197,160,89,0.45)] text-[#EED8A1] text-xs tracking-[0.2em] uppercase hover:bg-[rgba(197,160,89,0.1)] transition-colors duration-300"
          >
            <MessageCircle size={15} />
            <span>+33 6 50 26 71 60</span>
          </a>
          <p className="mt-6 text-xs text-[#8A8270] tracking-[0.18em] uppercase">{t.footer_founder}</p>
        </div>

        <div className="mt-16 select-none pointer-events-none text-center">
          <span className="font-serif text-[13vw] leading-none tracking-tight text-[rgba(197,160,89,0.06)] whitespace-nowrap">
            GOLDEN VALLEY
          </span>
        </div>

        <div className="mt-10 pt-8 border-t border-[rgba(197,160,89,0.1)] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-[#6E6858] tracking-wider">{t.footer_rights}</p>
          <p className="text-[11px] text-[#6E6858] tracking-wider">{t.footer_discretion}</p>
        </div>
      </div>
    </footer>
  );
};
